import FormItem from '@packages/ui/form/form-item.tsx';
import { useTranslate } from '@tolgee/react';
import { CompactRadioInput } from '@packages/ui/form/input/compact-radio-input.tsx';

export enum OnlineOrderTemplate {
  DEFAULT = 'DEFAULT',
  CLASSIC = 'CLASSIC',
  SUSHI = 'SUSHI',
}

export interface OnlineOrderTemplateSelectorProps {
  value: OnlineOrderTemplate;
  onChange: (template: OnlineOrderTemplate) => void;
}

export default function OnlineOrderTemplateSelector(props: OnlineOrderTemplateSelectorProps) {
  const { value, onChange } = props;
  const { t } = useTranslate();

  const templateOptions = [
    { name: t('online-order.setting-page.edit.general.template.default', 'Default'), value: OnlineOrderTemplate.DEFAULT },
    { name: t('online-order.setting-page.edit.general.template.classic', 'Classic'), value: OnlineOrderTemplate.CLASSIC },
    { name: t('online-order.setting-page.edit.general.template.sushi', 'Sushi'), value: OnlineOrderTemplate.SUSHI },
  ];

  return (
    <FormItem title={t('online-order.setting-page.edit.general.template.title', 'Template')} className="max-w-md">
      <CompactRadioInput options={templateOptions} value={value} onChange={onChange} />
    </FormItem>
  );
}
